import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|Program History|Continuing Education|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.CredentialContinuingEducation,
	portal: 'SP',
};
const columnHeadingDescriptionStart = 'Column heading for: ';

export type SPCandidateCECurrentLocNames =
	| `SPCandidateCECurrentTitleSection`
	| `SPCandidateCECurrentLabelName`
	| `SPCandidateCECurrentLabelActiveDate`
	| `SPCandidateCECurrentLabelExpireDate`
	| `SPCandidateCECurrentLabelUpdated`
	| `SPCandidateCECurrentLabelReviewStatus`
	| `SPCandidateCECurrentLabelInvalid`
	| `SPCandidateCECurrentLabelDataProvider`
	| `SPCandidateCECurrentLabelCourseName`
	| `SPCandidateCECurrentLabelDocumentation`
	| `SPCandidateCECurrentLabelPoints`;

export const spCandidateCECurrentLocs: LocDefs<SPCandidateCECurrentLocNames> = {
	SPCandidateCECurrentTitleSection: {
		defaultValue: 'Current',
		description: `Continuing education current section title.`,
		displayPath: `${pathStart}Continuing Education Title`,
		displayType: 'Title',
		...sharedProperties,
	},
	SPCandidateCECurrentLabelName: {
		defaultValue: 'Name',
		description: `${columnHeadingDescriptionStart}Name.`,
		displayPath: `${pathStart}Name`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPCandidateCECurrentLabelActiveDate: {
		defaultValue: 'Active Date',
		description: `${columnHeadingDescriptionStart}Active Date.`,
		displayPath: `${pathStart}Active Date`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPCandidateCECurrentLabelExpireDate: {
		defaultValue: 'Expire Date',
		description: `${columnHeadingDescriptionStart}Expire Date.`,
		displayPath: `${pathStart}Expire Date`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPCandidateCECurrentLabelUpdated: {
		defaultValue: 'Updated',
		description: `${columnHeadingDescriptionStart}Updated.`,
		displayPath: `${pathStart}Updated`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPCandidateCECurrentLabelReviewStatus: {
		defaultValue: 'Review Status',
		description: `${columnHeadingDescriptionStart}Review Status.`,
		displayPath: `${pathStart}Review Status`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPCandidateCECurrentLabelInvalid: {
		defaultValue: 'Invalid',
		description: `${columnHeadingDescriptionStart}Invalid.`,
		displayPath: `${pathStart}Invalid`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPCandidateCECurrentLabelDataProvider: {
		defaultValue: 'Data Provider',
		description: `${columnHeadingDescriptionStart}Data Provider.`,
		displayPath: `${pathStart}Data Provider`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPCandidateCECurrentLabelCourseName: {
		defaultValue: 'Course Name',
		description: `${columnHeadingDescriptionStart}Course Name.`,
		displayPath: `${pathStart}Course Name`,
		displayType: 'Label',
		...sharedProperties,
		feature: HubFeature.CredentialContinuingEducationCeCourseName,
	},
	SPCandidateCECurrentLabelDocumentation: {
		defaultValue: 'Documentation',
		description: `${columnHeadingDescriptionStart}Documentation.`,
		displayPath: `${pathStart}Documentation`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPCandidateCECurrentLabelPoints: {
		defaultValue: 'Points',
		description: `${columnHeadingDescriptionStart}Points.`,
		displayPath: `${pathStart}Points`,
		displayType: 'Label',
		...sharedProperties,
	},
};

export type SPCandidateCECurrentLocType = LocMap<SPCandidateCECurrentLocNames>;
